export default {
  title: 'Montant minimum de paiement : les paiements ne peuvent pas être entre {{rangeStart}} - {{rangeEnd}}',
  description: 'Exception : si vous avez un article gratuit, vous pouvez valider avec un total de {{amount}}.',
};
